import React from 'react';
import { track } from '@src/services/analytics';

import { useWidgetId } from '@src/core/IdProvider';
import { useAppSelector, useAppDispatch } from '@src/core/hooks';
import HeaderStepsNavigation from '@src/components/reusable/HeaderStepsNavigation';
import { productAdderStepState, clearHighlightedProductAdder } from '@src/stores/product';

interface ProductAdderHeaderProps {
  title?: string;
  onClose?: (callback: () => void) => void;
  hideSteps?: boolean;
}

const ProductAdderHeader = (props: Readonly<ProductAdderHeaderProps>) => {
  const { title, onClose, hideSteps } = props;

  const widgetId = useWidgetId();
  const dispatch = useAppDispatch();
  const { currentStep, steps } = useAppSelector(productAdderStepState(widgetId));

  const closeModal = () => {
    track('productAdderClose');
    if (onClose) {
      onClose(() => {
        dispatch(clearHighlightedProductAdder());
      });

      return;
    }

    dispatch(clearHighlightedProductAdder());
  };

  return (
    <HeaderStepsNavigation
      steps={steps}
      stepType='product'
      onClose={closeModal}
      title={title ?? ''}
      currentStep={currentStep}
      hideSteps={hideSteps}
    />
  );
};

export default ProductAdderHeader;
